/**
 * Merges new event products with existing ones in the basket,
 * summing quantities and combining attendee lists.
 */
export function mergeEventProducts(newProducts, existingProducts = []) {
  return newProducts.map((product, index) => {
    const existingProduct = existingProducts[index];
    const existingQuantity = Number(existingProduct?.Quantity || 0);
    const newQuantity = Number(product.Quantity) + existingQuantity;

    return {
      ...product,
      Quantity: String(newQuantity),
      Attendees: [
        ...(product.Attendees || []),
        ...(existingProduct?.Attendees || []),
      ],
    };
  });
}
